export const LoadingElement = {
    namespaced: true,

    state: {
        elementIds: []
    },

    mutations: {
        push: function (state, id) {
            state.elementIds.push(id);
        },

        delete: function (state, id) {
            let index = state.elementIds.indexOf(id);
            if (index !== -1) {
                state.elementIds.splice(index, 1);
            }
        }
    }
}
